module.exports = __webpack_public_path__ + "img/m2-screenshot-06.0f17178b.png";